/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

/**
 * Form for editing an admitted workload subject. Every field but id is optional; an omitted field is left unchanged.
 */
export type UpdateWorkloadSubjectForm = {
  /**
   * The agent whose policy the admitted workload inherits. Shared with any admission of the same subject under the same issuer at the other tier.
   */
  agentId?: string | undefined;
  /**
   * The admission id.
   */
  id: string;
  /**
   * Optional label, for platforms whose subjects are not self-describing. Trimmed on write; blank clears it.
   */
  name?: string | undefined;
  /**
   * Replaces the admission's tags; an empty list clears them. Trimmed and de-duplicated on write, then limited to 40 tags of at most 64 characters each.
   */
  tags?: Array<string> | undefined;
};

/** @internal */
export type UpdateWorkloadSubjectForm$Outbound = {
  agent_id?: string | undefined;
  id: string;
  name?: string | undefined;
  tags?: Array<string> | undefined;
};

/** @internal */
export const UpdateWorkloadSubjectForm$outboundSchema: z.ZodMiniType<
  UpdateWorkloadSubjectForm$Outbound,
  UpdateWorkloadSubjectForm
> = z.pipe(
  z.object({
    agentId: z.optional(z.string()),
    id: z.string(),
    name: z.optional(z.string()),
    tags: z.optional(z.array(z.string())),
  }),
  z.transform((v) => {
    return remap$(v, {
      agentId: "agent_id",
    });
  }),
);

export function updateWorkloadSubjectFormToJSON(
  updateWorkloadSubjectForm: UpdateWorkloadSubjectForm,
): string {
  return JSON.stringify(
    UpdateWorkloadSubjectForm$outboundSchema.parse(updateWorkloadSubjectForm),
  );
}
